/**
 * Các tập giá trị cố định dùng chung cho DB, API và web.
 * Thứ tự trong mảng là thứ tự hiển thị; thêm giá trị mới thì thêm vào cuối.
 */

export const USER_ROLES = ["user", "support", "editor", "admin"] as const;
export type UserRole = (typeof USER_ROLES)[number];

export const USER_STATUSES = ["active", "locked", "deleted"] as const;
export type UserStatus = (typeof USER_STATUSES)[number];

/** Nhóm việc để ghi giờ học và vẽ báo cáo. */
export const ACTIVITIES = ["test", "part", "gram", "vocab", "fix", "dict", "other"] as const;
export type Activity = (typeof ACTIVITIES)[number];

export const TEST_KINDS = ["ets", "mock", "rc", "event"] as const;
export type TestKind = (typeof TEST_KINDS)[number];

export const CONTENT_STATUSES = ["draft", "review", "published", "archived"] as const;
export type ContentStatus = (typeof CONTENT_STATUSES)[number];

export const VISIBILITIES = ["public", "hidden"] as const;
export type Visibility = (typeof VISIBILITIES)[number];

export const ATTEMPT_KINDS = ["full", "part", "practice", "drill", "event"] as const;
export type AttemptKind = (typeof ATTEMPT_KINDS)[number];

export const ATTEMPT_MODES = ["exam", "practice"] as const;
export type AttemptMode = (typeof ATTEMPT_MODES)[number];

export const ATTEMPT_STATUSES = ["in_progress", "submitted", "abandoned"] as const;
export type AttemptStatus = (typeof ATTEMPT_STATUSES)[number];

/** 8 nhóm bẫy chuẩn (canonTrap trong demo). */
export const TRAP_KEYS = [
  "echo",
  "overreach",
  "role",
  "cross",
  "vocab",
  "insert",
  "reverse",
  "swap",
] as const;
export type TrapKey = (typeof TRAP_KEYS)[number];

/** `quick` là ghi nhanh; 5 giá trị còn lại là trang sổ theo phương pháp. */
export const NOTE_METHODS = ["quick", "cornell", "box", "map", "mind", "plain"] as const;
export type NoteMethod = (typeof NOTE_METHODS)[number];

export const CALENDAR_SKILLS = ["nghe", "doc", "thithu", "nguphap", "tuvung"] as const;
export type CalendarSkill = (typeof CALENDAR_SKILLS)[number];

export const ENTITLEMENT_SOURCES = ["code", "payment", "admin", "promo"] as const;
export type EntitlementSource = (typeof ENTITLEMENT_SOURCES)[number];

export const CODE_STATUSES = ["active", "redeemed", "revoked", "expired"] as const;
export type CodeStatus = (typeof CODE_STATUSES)[number];

export const REPORT_TYPES = ["dapan", "noidung", "giaithich", "audio", "anh", "khac"] as const;
export type ReportType = (typeof REPORT_TYPES)[number];

export const DEFAULT_TIMEZONE = "Asia/Ho_Chi_Minh";
/** Mục tiêu phút học mỗi ngày khi người dùng chưa chọn. */
export const DEFAULT_DAILY_GOAL_MINUTES = 60;
/** Số giây không thao tác thì tạm dừng ghi giờ học. */
export const DEFAULT_IDLE_LIMIT_SEC = 180;
